// extracted by mini-css-extract-plugin
export var borderbottom = "QuickLinksEmbedded-module--borderbottom--9f228";
export var bordersection = "QuickLinksEmbedded-module--bordersection--b56f1";
export var embeddedquicklinkitem = "QuickLinksEmbedded-module--embeddedquicklinkitem--5ddd4";
export var iconwrapper = "QuickLinksEmbedded-module--iconwrapper--74bee";
export var quicklinks = "QuickLinksEmbedded-module--quicklinks--ff5d8";
export var quicklinksinner = "QuickLinksEmbedded-module--quicklinksinner--1253b";
export var quicklinkssectiontitle = "QuickLinksEmbedded-module--quicklinkssectiontitle--7b980";
export var quicklinkstitle = "QuickLinksEmbedded-module--quicklinkstitle--b031a";
export var quicklinkswrapper = "QuickLinksEmbedded-module--quicklinkswrapper--23800";
export var swiper = "QuickLinksEmbedded-module--swiper--c2030";
export var swiperwrapper = "QuickLinksEmbedded-module--swiperwrapper--7f067";